import React from 'react';
import { Box, Typography } from '@mui/material';
import { FRONT_DOOR_FOOTER } from '../../constants/regulatoryFooter';

const tok = (t) => `var(--dwlf-${t})`;

/**
 * The frame of a page anyone may open, signed in or not (the waitlist, the privacy notice): the
 * front door's header and footer. Links are plain anchors, not router links, because in the identity
 * build these pages render outside the router the signed-in app runs in.
 */
export default function PublicPage({ children, maxWidth = 560 }) {
  return (
    <Box component="main" sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: tok('bg'), color: tok('text') }}>
      <Box component="header" sx={{ px: { xs: 2, md: 6 }, py: 3 }}>
        <Box component="a" href="/" sx={{ fontFamily: '"Space Grotesk", sans-serif', fontWeight: 700, fontSize: '1.375rem', letterSpacing: '0.1em', color: tok('accent'), textDecoration: 'none' }}>
          DWLF
        </Box>
      </Box>
      <Box sx={{ flex: 1, px: { xs: 2, md: 6 }, py: { xs: 2, md: 6 } }}>
        <Box sx={{ maxWidth, mx: 'auto' }}>{children}</Box>
      </Box>
      <Box component="footer" sx={{ px: { xs: 2, md: 6 }, py: 3, borderTop: `1px solid ${tok('ink-08')}` }}>
        <Typography sx={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: '0.75rem', color: tok('ink-50') }}>
          {FRONT_DOOR_FOOTER}{' '}
          <Box component="a" href="/privacy" sx={{ color: tok('ink-50') }}>
            Privacy
          </Box>
        </Typography>
      </Box>
    </Box>
  );
}
